export default __webpack_public_path__ + "static/media/018.2cf10537.jpg";